import { StockUnionType } from 'types/stock'

export const BREAD_TYPES: { id: StockUnionType; name: string }[] = [
  { id: 'daily', name: '当日' },
  { id: 'preorder', name: '事前予約' },
  { id: 'delivery', name: '取り寄せ' },
]

export const BREAD_STOCK_TYPES: { id: StockUnionType; name: string }[] = [
  { id: 'daily', name: '当日在庫なし' },
  { id: 'preorder', name: '事前在庫なし' },
  { id: 'delivery', name: '取り寄せ在庫なし' },
]
